module.exports = __webpack_public_path__ + "img/blog.66947d3.svg";